import React, { useState, useEffect } from "react"
import Header from "../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Grid, Card, CardContent, Typography, TextField, Button, Modal } from "@mui/material"

import BackIcon from "../../../../components/BackIcon"

import { NavLink, useNavigate, useLocation } from "react-router-dom"
import HorizontalLinearStepper from "../../components/HorizontalLinearStepper"

import { useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../../components/CustomBackdrop"

import { VerificacionDocumentalProvider } from "../../Contexts/VerificacionDocumentalContext"
import Obturador from "../../../../components/Obturador/Obturador"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const styleModalObturador = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
}

const VerificacionCodigoDeBarras = () => {
  const [artCode, setArtCode] = useState("")
  const [refetchKey, setRefetchKey] = useState(Date.now()) // Estado para forzar el refetch
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const {
    data: fetchedCodigoBarra = {},
    isError: isLoadingCodigoBarraError,
    isFetching: isFetchingCodigoBarra,
    isLoading: isLoadingCodigoBarra,
    refetch: refetchCodigoBarra,
  } = useGetCodigoBarra()

  // READ hook (get FiltrosCB from api)
  function useGetCodigoBarra() {
    return useQuery({
      queryKey: ["VerificacionCodigoBarras"],
      queryFn: async () => {
        // send api request here
        let response = await fetchwrapper(`/verificacionCodigoDeBarras/getCodigoBarraFixed/${artCode}`)
        response = await response.json()
        response = response?.data
        return response
      },
      retry: 1,
      refetchOnWindowFocus: false,
      enabled: false,
    })
  }

  const isValidCodeArticulo = (code) => {
    const formatCode = String(code).trim()

    return formatCode !== null && formatCode !== "" && /^\d+$/.test(formatCode)
  }
  useEffect(() => {
    const asyncRefetchCodigoBarra = async () => await refetchCodigoBarra(artCode)
    if (isValidCodeArticulo(artCode)) {
      // Solo se ejecuta si artCode es valido
      asyncRefetchCodigoBarra()
      handleOpen() // Abre el modal después de la consulta
    }
  }, [artCode, refetchCodigoBarra, refetchKey]) // Este efecto se ejecuta cada vez que artCode cambie
  // const searchArticulo = async (e, artCode, data = {}) => {
  //   if (e) e.preventDefault()
  //   const navigateData = {
  //     codigoArticulo: artCode,
  //     ...data,
  //   }

  //   if (isValidCodeArticulo(navigateData?.codigoArticulo)) {
  //     setArtCode(navigateData.codigoArticulo)
  //     setRefetchKey(Date.now()) // Actualizar refetchKey para forzar el refetch
  //   } else {
  //     alert("Código de artículo inválido")
  //   }
  // }
  // const textIsAlreadyDecodedArticulo = (infoRead, closeModalQr) => {
  //   closeModalQr()
  //   const textDecoded = infoRead?.barcodeDataText

  //   if (textDecoded) {
  //     const data = {
  //       type: "codigoArticulo",
  //       codigoArticulo: `${textDecoded}`,
  //     }

  //     searchArticulo(null, data.codigoArticulo, data)
  //   } else {
  //     throw new Error("")
  //   }
  // }
  return (
    <>
      <Box sx={{ textAlign: "center" }}>
        {/* <Obturador
          scannerParams={{
            msg: "Escanea el código de barras",
            codeType: "bar",
          }}
          executeFunction={textIsAlreadyDecodedArticulo}
        /> */}
        <br />
        <br />

        <CustomBackdrop isLoading={isLoadingCodigoBarra || isFetchingCodigoBarra} />

        <Modal open={open} onClose={handleClose}>
          <Box sx={styleModalObturador}>
            {Object.keys(fetchedCodigoBarra).length === 0 ? (
              <div>No se encontró ningún código de barras asociado a ese artículo</div>
            ) : isLoadingCodigoBarraError ? (
              <div>Error al obtener la información</div>
            ) : (
              <div style={{ border: "1px solid #d3d3d3", borderRadius: "5px", padding: "10px" }}>
                <div style={{ borderBottom: "1px solid #d3d3d3", paddingBottom: "5px", marginBottom: "10px" }}>
                  <h4 style={{ margin: "0", color: "#333" }}>Resultados</h4>
                </div>
                <div>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>Código del artículo:</span> {fetchedCodigoBarra.artcodigo}{" "}
                  </p>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>Descripción del artículo:</span>{" "}
                    {fetchedCodigoBarra.artdescri}{" "}
                  </p>
                  <p>
                    <span style={{ fontWeight: "bolder" }}>Código de barra:</span> {fetchedCodigoBarra.artcodbarra}{" "}
                  </p>
                </div>
              </div>
            )}
          </Box>
        </Modal>
      </Box>
    </>
  )
}

const Formularios = () => {
  const navigate = useNavigate()
  // const location = useLocation();

  const {
    data: fetchedFormTransporte = [],
    isError: isLoadingFormTransporteError,
    isFetching: isFetchingFormTransporte,
    isLoading: isLoadingFormTransporte,
  } = useGetSpecificFormTransporte()
  // READ hook (get specific FormTransporte from api)
  function useGetSpecificFormTransporte() {
    return useQuery({
      queryKey: ["FormTransporte"],
      queryFn: async () => {
        // send api request here
        let response = await fetchwrapper(`/verificacionDocumental/getSpecificForm/Check List Transporte Recepción`)
        response = await response.json()
        return response.data
      },
      refetchOnWindowFocus: false,
    })
  }

  // const {
  //   data: fetchedFormRecepciones = [],
  //   isError: isLoadingFormRecepcionError,
  //   isFetching: isFetchingFormRecepcion,
  //   isLoading: isLoadingFormRecepcion,
  // } = useGetSpecificFormRecepcion();
  // //READ hook (get specific FormTransporte from api)
  // function useGetSpecificFormRecepcion() {
  //   return useQuery({
  //     queryKey: ["FormRecepcion"],
  //     queryFn: async () => {
  //       //send api request here
  //       let response = await fetchwrapper(
  //         `/verificacionDocumental/getSpecificForm/Acta de Recepción/${location.state.sgasoling}`
  //       );
  //       response = await response.json();
  //       return response.data;
  //     },
  //     refetchOnWindowFocus: false,
  //   });
  // }

  if (isLoadingFormTransporteError) {
    alert("No se pudieron encontrar los formularios")
    navigate(-1)
  }
  return (
    <VerificacionDocumentalProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <BackIcon />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 30px 30px 30px",
              fontSize: "25px",
            }}
          >
            <b>Formularios</b>
          </div>
          <VerificacionCodigoDeBarras />
          <CustomBackdrop
            isLoading={
              isLoadingFormTransporte || isFetchingFormTransporte
              // ||isLoadingFormRecepcion ||
              // isFetchingFormRecepcion
            }
          />

          <Box className={StyledRoot}>
            <HorizontalLinearStepper
              fetchedForms={[
                // ...fetchedFormRecepciones,
                ...fetchedFormTransporte,
              ]}
              isReadable={false}
            />
          </Box>
        </div>
      </ThemeProvider>
    </VerificacionDocumentalProvider>
  )
}

export default Formularios
